import React from "react";
import "./Skills.scss";
import { FaReact, FaJava, FaPython, FaDocker } from "react-icons/fa";
import {
  SiSpringboot,
  SiMariadb,
  SiMysql,
  SiRedis,
  SiFlask,
  SiJavascript,
  SiTypescript,
  SiVuedotjs,
  SiFastapi,
  SiPostgresql,
  SiRabbitmq,
  SiAmazonwebservices,
} from "react-icons/si";
import useInView from "../hooks/useInView";

const ICONS = {
  Java: { Icon: FaJava, color: "#e76f00" },
  "Spring Boot": { Icon: SiSpringboot, color: "#6db33f" },
  MariaDB: { Icon: SiMariadb, color: "#7ea6c4" },
  MySQL: { Icon: SiMysql, color: "#6fa8d4" },
  Redis: { Icon: SiRedis, color: "#ff6b5e" },
  Python: { Icon: FaPython, color: "#6fa8dc" },
  Flask: { Icon: SiFlask, color: "#e6e6e6" },
  React: { Icon: FaReact, color: "#61dafb" },
  Docker: { Icon: FaDocker, color: "#4fa9f5" },
  PostgreSQL: { Icon: SiPostgresql, color: "#7aa6d6" },
  AWS: { Icon: SiAmazonwebservices, color: "#ff9f2e" },
  JavaScript: { Icon: SiJavascript, color: "#f7df1e" },
  TypeScript: { Icon: SiTypescript, color: "#5c9ee0" },
  "Vue.js": { Icon: SiVuedotjs, color: "#42b883" },
  "React Native": { Icon: FaReact, color: "#61dafb" },
  FastAPI: { Icon: SiFastapi, color: "#2ec4b6" },
  RabbitMQ: { Icon: SiRabbitmq, color: "#ff8a5b" },
};

const GROUPS = [
  {
    level: "Proficient",
    items: ["React", "TypeScript", "JavaScript", "Java", "Spring Boot", "MySQL"],
  },
  {
    level: "Familiar",
    items: ["React Native", "MariaDB", "Redis", "Python", "Flask", "AWS", "Docker"],
  },
  {
    level: "Exposed",
    items: ["Vue.js", "FastAPI", "RabbitMQ", "PostgreSQL"],
  },
];

function Skills() {
  const [ref, inView] = useInView();

  return (
    <section className="section skills" id="skills" ref={ref}>
      <div className="container">
        <h2 className={`section-title reveal ${inView ? "is-in" : ""}`}>
          Skills
        </h2>

        {GROUPS.map((group, groupIndex) => (
          <div className="skill-group" key={group.level}>
            <h3 className="skill-level">{group.level}</h3>

            <div className="skill-grid">
              {group.items.map((name, index) => {
                const meta = ICONS[name];
                if (!meta) return null;
                const { Icon, color } = meta;

                return (
                  <div
                    className={`skill-cell reveal ${inView ? "is-in" : ""}`}
                    style={{
                      "--delay": `${groupIndex * 90 + index * 45}ms`,
                      "--icon": color,
                    }}
                    key={name}
                  >
                    <Icon aria-hidden="true" />
                    <span>{name}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
